import React, { useEffect, useState } from "react";

import { Box, Button, Text, useColorMode, useToast } from "@chakra-ui/react";
import { ErrorMessage, Form, Formik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  updateConsultantProfile,
  getConsultantProfile,
} from "../../../../../store/actions";
import { InputControl } from "formik-chakra-ui";

import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import {
  checkBgColorMode,
  checkColorMode,
  checkColorModeHover,
} from "../../../../global/changeColor";
import NmberInput from "../../../../global/NmberInput";
const SubmitSchema = Yup.object().shape({
  country: Yup.string().min(3).required("Required"),
  city: Yup.string().min(3).required("Required"),
  street: Yup.string().min(3).required("Required"),
  postel_code: Yup.string().min(3).required("Required"),
});

const Address = ({
  consultantProfile,
  updateConsultantProfile,
  getConsultantProfile,
  updateProfile,
}) => {
  const toast = useToast();
  const history = useHistory();
  const { colorMode } = useColorMode();
  const [edite, setEdite] = useState(false);
  const [initValue, setInitValue] = useState({
    country: "",
    city: "",
    street: "",
    postel_code: "",
  });

  const onFormSubmit = (value) => {
    const data = {
      name: consultantProfile.name,
      gmcNumber: consultantProfile.gmcNumber,
      yearsOfExperienceAsConsultant:
        consultantProfile.yearsOfExperienceAsConsultant,
      currentEmployer: consultantProfile.currentEmployer,
      jobTitle: consultantProfile.jobTitle,
      patientTypeId: consultantProfile.patientTypeId,
      consultationTypes: consultantProfile.consultationTypes,
      email: consultantProfile.email,
      mobile: consultantProfile.mobile,
      dateOfBirth: consultantProfile.dateOfBirth,
      gender: consultantProfile.gender,

      address: value,
    };
    updateConsultantProfile(
      data,
      history,
      toast,
      null,
      setEdite,
      getConsultantProfile
    );
  };
  useEffect(() => {
    if (consultantProfile) {
      setInitValue({
        ...initValue,
        country: consultantProfile.address.country
          ? consultantProfile.address.country
          : "",
        city: consultantProfile.address.city,
        street: consultantProfile.address.street,
        postel_code: consultantProfile.address.postelCode,
      });
    }
  }, [consultantProfile]);
  const renderView = () => {
    if (edite) {
      return (
        <Formik
          initialValues={initValue}
          enableReinitialize
          onSubmit={onFormSubmit}
          validationSchema={SubmitSchema}
        >
          {({ values, handleBlur, handleChange }) => (
            <Form>
              <div className="col-12 d-flex flex-wrap justify-content-between align-items-center">
                <div>
                  <Text fontSize="lg" color="secondary" fontWeight="semibold">
                    {" "}
                    My Address
                  </Text>
                </div>
                <div className="w-100 text-end my-2">
                  <Button
                    width={"50px"}
                    height="50px"
                    bg="#f3e9eb"
                    _hover={{ bg: "#f3d3da" }}
                    fontSize="20px"
                    color="#D42C51"
                    className="me-2"
                    onClick={() => setEdite(false)}
                    type="button"
                  >
                    <i className="fas fa-times"></i>
                  </Button>

                  <Button
                    width={"50px"}
                    height="50px"
                    bg={"secondary"}
                    _hover={{ bg: "secondary_hover" }}
                    fontSize="20px"
                    type="submit"
                    color="#fff"
                    isLoading={updateProfile.loading}
                  >
                    <i className="fas fa-save"></i>
                  </Button>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 mt-3">
                  <label className="chakra-form__label mb-2" htmlFor="country">
                    Country
                  </label>
                  <CountryDropdown
                    classes={`${
                      colorMode === "dark" ? "css-xpongc" : "css-1c6j008"
                    } text-secondary`}
                    name="country"
                    defaultOptionLabel="Select a country"
                    value={values.country}
                    onChange={(_, e) => handleChange(e)}
                    onBlur={(_, e) => handleBlur(e)}
                  />

                  <ErrorMessage
                    name="address.country"
                    component="div"
                    className="text-danger"
                    style={{ fontSize: "14px" }}
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label className="chakra-form__label mb-2" htmlFor="country">
                    City
                  </label>
                  <RegionDropdown
                    classes={`${
                      colorMode === "dark" ? "css-xpongc" : "css-1c6j008"
                    } text-secondary`}
                    name="city"
                    blankOptionLabel="No country selected"
                    defaultOptionLabel="Now select a City"
                    country={values.country}
                    value={values.city}
                    onChange={(_, e) => handleChange(e)}
                    onBlur={(_, e) => handleBlur(e)}
                  />

                  <ErrorMessage
                    name="address.city"
                    component="div"
                    className="text-danger"
                    style={{ fontSize: "14px" }}
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <InputControl
                    name={"street"}
                    label="Street"
                    inputProps={{ placeholder: "Street" }}
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <InputControl
                    name="postel_code"
                    label="Postal Code"
                    inputProps={{ placeholder: "Postal Code" }}
                  />
                </div>
              </div>
            </Form>
          )}
        </Formik>
      );
    } else {
      return (
        <>
          <div className="col-12 d-flex justify-content-between align-items-center">
            <Text fontSize="lg" color={"secondary"} fontWeight="semibold">
              {" "}
              My Address
            </Text>
            <Button
              width={"50px"}
              height="50px"
              bg={checkColorMode(colorMode)}
              _hover={{ bg: checkColorModeHover(colorMode) }}
              fontSize="17px"
              color={"white"}
              onClick={() => setEdite(true)}
            >
              <i className="fas fa-pen"></i>
            </Button>
          </div>

          <div className="col-12 d-flex flex-wrap">
            <div className="col-md-4 col-12 p-0 mt-3">
              <Text fontWeight="semibold" color={"smallTextGray"}>
                Country
              </Text>
              <Text fontSize="sm" color={checkColorMode(colorMode)}>
                {consultantProfile ? consultantProfile.address.country : "null"}
              </Text>
            </div>

            <div className="col-md-4 col-12 p-0 mt-3">
              <Text fontWeight="semibold" color={"smallTextGray"}>
                City
              </Text>
              <Text fontSize="sm" color={checkColorMode(colorMode)}>
                {consultantProfile ? consultantProfile.address.city : "null"}
              </Text>
            </div>

            <div className="col-md-4 col-12 p-0  mt-3">
              <Text fontWeight="semibold" color={"smallTextGray"}>
                Street
              </Text>
              <Text fontSize="sm" color={checkColorMode(colorMode)}>
                {consultantProfile ? consultantProfile.address.street : "null"}
              </Text>
            </div>

            <div className="col-md-4 col-12 p-0  mt-4">
              <Text fontWeight="semibold" color={"smallTextGray"}>
                Postal code
              </Text>
              <Text fontSize="sm" color={checkColorMode(colorMode)}>
                {consultantProfile
                  ? consultantProfile.address.postelCode
                  : "null"}
              </Text>
            </div>
          </div>
        </>
      );
    }
  };
  return (
    <Box
      bg={checkBgColorMode(colorMode)}
      className="MyInfo rounded shadow-sm p-4  row m-0 flex-wrap mb-4"
    >
      {renderView()}
    </Box>
  );
};
const mapStateToProps = (state) => {
  return {
    updateProfile: state.updateProfile,
  };
};
export default connect(mapStateToProps, {
  getConsultantProfile,
  updateConsultantProfile,
})(Address);
